import { css } from '@emotion/react';
import { ProColors } from '../../aura';

type BodyProps = {
  text: string;
};

export function Body(props: BodyProps): JSX.Element {
  return (
    <div
      className="aura--copy-normal"
      css={css({
        color: ProColors.navy[500],
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
      })}
    >
      {props.text}
    </div>
  );
}
